import React, { useMemo } from "react";
import "../../styles/reading/FinalReadingModal.scss";
import { useNavigate } from "react-router-dom";
import { encryptUrlSafe } from "../../utils/encryption";
import Rive from "@rive-app/react-canvas";
import useAppTranslation from "../../hooks/useAppTranslation";

const FinalReadingModal = ({
  onBack,
  pageName,
  onClose,
  isAudio,
  isMobile,
}) => {
  const { t, language } = useAppTranslation("components/reading/finalReadingModal");
  // NOTE: 처음부터 다시 읽기 or 나만의 서재로 돌아가기
  const navigate = useNavigate();

  const randomRiv = useMemo(() => {
    const rivs = [
      "/riv/utils/modals/reading-finish-arial.riv",
      "/riv/utils/modals/reading-finish-nikki.riv",
    ];
    return rivs[Math.floor(Math.random() * rivs.length)];
  }, []);

  const goPage = () => {
    navigate(`/${pageName}`);
  };
  const goAIMaigkid = () => {
    window.close();
  };

  const handleShare = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const bookId =
      queryParams.get("bookID") || localStorage.getItem("book_id");

    if (!bookId) {
      alert(t("alerts.missingBookId"));
      return;
    }

    const shareUrl = `${window.location.origin}/${
      isAudio ? "audio-share" : "share"
    }?book_id=${encryptUrlSafe(bookId)}`;

    // 클립보드에 복사
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => {
        alert(t("alerts.shareCopied"));
      })
      .catch(() => {
        alert(t("alerts.shareFailed"));
      });
  };

  const getReturnLabel = () => {
    if (pageName === "storyland") {
      return t("actions.backToStoryland");
    }

    if (pageName === "myStorybook") {
      return t("actions.backToLibrary");
    }

    return "";
  };

  const readFinishImage = useMemo(() => {
    if (language === "ko") {
      return "/images/utils/modal/read_finish.webp";
    }

    if (language === "ru") {
      return "/images/utils/modal/read-finish-ru.webp";
    }

    if (language === "vi") {
      return "/images/utils/modal/read-finish-vi.webp";
    }

    return "/images/utils/modal/read-finish-en.webp";
  }, [language]);

  return (
    <>
      <section
        className={`rechoice-section ${isMobile ? "mobile-final-modal" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="inner">
          <figure className="close-modal-btn" onClick={onClose}>
            <img src="/images/utils/modal/close.svg" alt={t("actions.close")} />
            <span className="close-text">{t("actions.close")}</span>
          </figure>

          {!isMobile && (
            <>
              <div className="title-wrapper">
                <img
                  src={readFinishImage}
                  alt={t("title")}
                  className="read-finish-img"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="character-rive">
                <Rive src={randomRiv} />
              </div>
            </>
          )}

          <div className="modal-buttons-group">
            <p className="re-btn from-beginning-btn" onClick={() => onBack()}>
              <img
                src="/images/utils/modal/refresh.svg"
                alt=""
                className="btn-icon"
              />
              {t("actions.readAgain")}
            </p>
            <div className="sub-buttons">
              {pageName !== "storyland" && (
                <p className="re-btn share-btn" onClick={handleShare}>
                  <img
                    src="/images/utils/modal/share.svg"
                    alt=""
                    className="btn-icon"
                  />
                  {t("actions.share")}
                </p>
              )}
              {!isMobile && (
                <>
                  {pageName === "aimagickid" ? (
                    <p
                      className="re-btn my-library-btn"
                      onClick={() => goAIMaigkid()}
                    >
                      {t("actions.backToAIMagickid")}
                    </p>
                  ) : pageName === "storyland" || pageName === "myStorybook" ? (
                    <p
                      className="re-btn my-library-btn"
                      onClick={() => goPage()}
                    >
                      <img
                        src="/images/utils/modal/book-open.svg"
                        alt=""
                        className="btn-icon"
                      />
                      {getReturnLabel()}
                    </p>
                  ) : null}
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FinalReadingModal;
